import React, { useState } from "react";
import { ModalXoa } from "./ModalXoa";

export const BtnXoa = ({ item, onReload, disabled }) => {
    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
    };
    return (
        <>
            <a type="button" className="popover-basic" onClick={handleShow} disabled={disabled}>
				<img src="/app-assets/images/icon-xoa-v2.png" title="Xóa" />
			</a>
            {show && <ModalXoa id={item.Id} show={show} onHide={() => setShow(false)} onSaved={() => {setShow(false); onReload();}} />}
        </>
    );
};